import {
  createContext,
  useEffect,
  useContext as useReactContext,
  useState,
} from "react";
import { useAppointment } from "../hooks/useAppointment";

const MODAL_DEFAULT_STATE = {
  state: null,
  isOpen: false,
  open: () => {},
  close: () => {},
};

export const Context = createContext({
  id: 0,
  onClose: () => {},
  refetchAppointments: () => {},
  modals: {
    fee: MODAL_DEFAULT_STATE,
    notification: MODAL_DEFAULT_STATE,
    confirmCancel: MODAL_DEFAULT_STATE,
    checkin: MODAL_DEFAULT_STATE,
  },
});

export const useContext = () => {
  const context = useReactContext(Context);

  const { appointment, refetchAppointment, isAppointmentFetching } =
    useAppointment(context.id);

  const [selectedProvider, setSelectedProvider] = useState(0);
  const [selectedAdditionalProvider, setSelectedAdditionalProvider] =
    useState(0);

  useEffect(() => {
    if (!selectedProvider && appointment?.provider) {
      setSelectedProvider(appointment.provider.id);
    }

    if (!selectedAdditionalProvider && appointment?.additionalProviderId) {
      setSelectedAdditionalProvider(appointment.additionalProviderId);
    }
  }, [
    selectedProvider,
    selectedAdditionalProvider,
    appointment?.provider,
    appointment?.additionalProviderId,
  ]);

  return {
    ...context,
    appointment,
    refetchAppointment,
    isAppointmentFetching,
    selectedProvider: {
      value: selectedProvider,
      setValue: setSelectedProvider,
    },
    selectedAdditionalProvider: {
      value: selectedAdditionalProvider,
      setValue: setSelectedAdditionalProvider,
    },
  };
};
